import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "dfa51f7d-41c5-42a9-94f9-125e533cacde",
  title: "Base Training: Pfitzinger/Latter: Up to 30 miles per week, 10-week schedule",
  raceType: "Base",
  units: "miles",
  workouts: [
    // Week 1
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 6 miles",
      totalDistance: 6,
    },
    // Week 2
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 7 miles",
      totalDistance: 7,
    },
    // Week 3
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 7 miles",
      totalDistance: 7,
    },
    // Week 4
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 5 miles w/ 6x100m strides",
      totalDistance: 5,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 7 miles",
      totalDistance: 7,
    },
    // Week 5
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Lactate threshold 6 miles w/ 16 min tempo",
      totalDistance: 6,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 8 miles",
      totalDistance: 8,
    },
    // Week 6
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles w/ 6x100m strides",
      totalDistance: 6,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 8 miles",
      totalDistance: 8,
    },
    // Week 7
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Lactate threshold 6 miles w/ 18 min tempo",
      totalDistance: 6,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 8 miles",
      totalDistance: 8,
    },
    // Week 8
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles w/ 6x100m strides",
      totalDistance: 7,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 9 miles",
      totalDistance: 9,
    },
    // Week 9
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Lactate threshold 7 miles w/ 20 min tempo",
      totalDistance: 7,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 9 miles",
      totalDistance: 9,
    },
    // Week 10
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles w/ 8x100m strides",
      totalDistance: 8,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "Endurance 9 miles",
      totalDistance: 9,
    },
  ]
} as BuiltInPlan;